require('es6-promise').polyfill()
require('./bootstrap')
import Vue from 'vue';
window.Vue = Vue;
import moment from 'moment';
import * as Sentry from '@sentry/browser';
Sentry.init({
    dsn: window.SENTRY_LARAVEL_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

window.moment = moment;
import VueI18n from 'vue-i18n'
import en from '../public/locales/en.json';
import fr from '../public/locales/fr.json';
const i18n = new VueI18n({
    locale: 'en',
    messages: { en, fr }
});


import NProgress from 'nprogress';
import VueLazyload from 'vue-lazyload'

const VueInputMask = require('v-mask').default;
Vue.use(VueInputMask);
Vue.use(VueLazyload)
Vue.use(i18n)

window.NProgress = NProgress;
NProgress.configure({ easing: 'ease', speed: 500 });
NProgress.configure({ showSpinner: false });//Turn off loading spinner by setting it

import router from "./router";
import helpers from "../resources/assets/js/helpers";
import store from "./store";
Vue.mixin({
    methods:helpers
});

Vue.component('front-app', () => import('./components/AppComponent'));

new Vue({
    el: "#front-app",
    store,
    router,
    i18n,
});
